/**
 * Copyright (c) Microsoft. All rights reserved.
 */

 import { LogProvider } from './Interfaces';

 /**
  * Util that encapsulates lifecycle of active trouter URL and manages waiter for the URL via promise
  */
 export class TrouterUrlPromise {
    private url?: string;
    private pendingPromise?: Promise<string>;
    private pendingPromiseResolveRef?: Function;
    private pendingPromiseRejectRef?: Function;

    public constructor(private logger: LogProvider) {
    }

    // tslint:disable-next-line:promise-function-async
    public getPromise(): Promise<string> {
        if (this.url !== undefined) {
            this.logger.debug(`[TrouterUrlPromise] returning previously resolved url: ${this.url}`);

            return Promise.resolve(this.url);
        }

        if (this.pendingPromise === undefined) {
            this.logger.debug('[TrouterUrlPromise] creating and returning promise');
            // tslint:disable-next-line:promise-must-complete
            this.pendingPromise = new Promise<string>((resolve, reject) => {
                this.pendingPromiseResolveRef = resolve;
                this.pendingPromiseRejectRef = reject;
            });
        } else {
            this.logger.debug('[TrouterUrlPromise] returning existing promise');
        }

        return this.pendingPromise;
    }

    public resolveUrl(url: string) {
        this.url = url;
        this.logger.debug(`[TrouterUrlPromise] got url: ${this.url}`);

        const resolveCallback = this.pendingPromiseResolveRef;
        this.pendingPromise = undefined;
        this.pendingPromiseResolveRef = undefined;
        this.pendingPromiseRejectRef = undefined;

        if (resolveCallback !== undefined) {
            this.logger.debug('[TrouterUrlPromise] resolving promise');
            resolveCallback(url);
        }
    }

    public rejectUrl(error: Error) {
        this.logger.debug('[TrouterUrlPromise] aborting');
        const rejectCallback = this.pendingPromiseRejectRef;
        this.url = undefined;
        this.pendingPromise = undefined;
        this.pendingPromiseResolveRef = undefined;
        this.pendingPromiseRejectRef = undefined;

        if (rejectCallback !== undefined) {
            this.logger.debug('[TrouterUrlPromise] rejecting promise');
            rejectCallback(error);
        }
    }

    public resetUrl() {
        this.logger.debug('[TrouterUrlPromise] resetting url');
        this.url = undefined;
    }
}



// WEBPACK FOOTER //
// ./lib_temp/TrouterUrlPromise.ts